function pad(value) {
  return String(value).padStart(2, "0");
}

export function formatDateToYMD(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function parseYMDToLocalDate(dateStr) {
  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(year, month - 1, day);
}

export function normalizeExecutionDate(dateStr) {
  return dateStr.split("T")[0];
}

export function formatExecutionDateForDisplay(dateStr, locale = "en-US") {
  return parseYMDToLocalDate(normalizeExecutionDate(dateStr)).toLocaleDateString(locale);
}
